import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

// #region Custom Classes

export interface ConfirmationDialogOptions extends MatDialogConfig {
    TitleText?: string;
    MessageText?: string;
    OKText?: string;
    CancelText?: string;
    IconColor?: string;
    IconName?: string;
    ShowIcon?: boolean;
}

// #endregion

@Component({
    selector: 'dialog-confirmation-component',
    styleUrls: ['confirmation.dialogcomponent.scss'],
    templateUrl: 'confirmation.dialogcomponent.html',
})
export class ConfirmationDialogComponent implements OnInit {
    title: string;
    message: string;
    iconcolor: string;
    iconname: string;
    oktext: string;
    canceltext: string;
    showIcon: boolean;

    constructor(
        public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
        @Inject(MAT_DIALOG_DATA) data: ConfirmationDialogOptions
    ) {
        this.title = data?.TitleText || 'Confirmation Requested...';
        this.message = data?.MessageText || '';
        this.iconcolor = data?.IconColor || 'primary';
        this.iconname = data?.IconName || 'help';
        this.oktext = data?.OKText || 'OK';
        this.canceltext = data?.CancelText || 'Cancel';
        this.showIcon = data?.ShowIcon != null ? data.ShowIcon : false;
    }

    CancelHandler() {
        this.dialogRef.close(null);
    }

    ngOnInit() {}

    OKHandler() {
        this.dialogRef.close(true);
    }
}
